import React, { useEffect, useState } from "react";
import "./ProductSinglePage.scss";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAsyncProductSingle,
  getSingleProductStatus,
} from "../../store/productSlice";
import { STATUS } from "../../utils/status";
import Loader from "../../components/Loader/Loader";
import { formatPrice } from "../../utils/helpers";
import {
  addToCartAsync,
  getCartMessageStatus,
  setCartMessageOff,
  setCartMessageOn,
} from "../../store/cartSlice";
import {
  addTofavorite,
  getfavoriteMessageStatus,
  setfavoriteMessageOff,
  setfavoriteMessageOn,
} from "../../store/favoriteSlice";

import CartMessage from "../../components/CartMessage/CartMessage";
import FavoriteMessage from "../../components/FavoriteMessage/FavoriteMessage";
import Footer1 from "../../components/Footer/Footer1";
import {
  fetchAsyncVendorProducts,
  getVendorProductById,
} from "../../store/vendorSlice";
import { IMAGE_URL1 } from "../../utils/apiURL";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { selectUser } from "../../store/authSlice"; // Assurez-vous que le chemin est correct

const ProductSinglePages = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  // const product = useSelector(getProductSingle);
  const productSingleStatus = useSelector(getSingleProductStatus);
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState("");
  const cartMessageStatus = useSelector(getCartMessageStatus);
  const favoriteMessageStatus = useSelector(getfavoriteMessageStatus);
  const product = useSelector((state) => getVendorProductById(state, id)); // Change to get by product ID
  const user = useSelector(selectUser); // Récupère l'utilisateur connecté
  const token = localStorage.getItem("token");

  useEffect(() => {}, [token]);

  // Fetch single product when `id` changes
  useEffect(() => {
    dispatch(fetchAsyncProductSingle(id))
      .unwrap()
      .then(() => {
        if (product) {
          dispatch(fetchAsyncVendorProducts(product.vendor_id));
        }
      });
  }, [id, dispatch]);

  useEffect(() => {}, [product]);

  // Charger les produits du vendeur après que le produit a été récupéré
  useEffect(() => {
    const fetchVendorProducts = async () => {
      if (product) {
        const vendorId = product.vendor_id;
        await dispatch(fetchAsyncVendorProducts(vendorId));
      }
    };

    const timer = setTimeout(fetchVendorProducts, 1000); // 1000 ms (1 seconde)
    return () => clearTimeout(timer); // Nettoyage pour éviter des appels supplémentaires
  }, [product, dispatch]);

  useEffect(() => {
    if (cartMessageStatus) {
      const timer = setTimeout(() => {
        dispatch(setCartMessageOff());
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessageStatus, dispatch]);

  useEffect(() => {
    if (favoriteMessageStatus) {
      const timer = setTimeout(() => {
        dispatch(setfavoriteMessageOff());
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [favoriteMessageStatus, dispatch]);

  useEffect(() => {
    if (product && product.product_images1) {
      setSelectedImage(product.product_images1);
    } else {
    }
  }, [product]);

  if (productSingleStatus === STATUS.LOADING) {
    return <Loader />;
  }

  const increaseQty = () => {
    setQuantity((prevQty) => {
      let tempQty = prevQty + 1;
      if (tempQty > product.stock) tempQty = product.stock;
      return tempQty;
    });
  };

  const decreaseQty = () => {
    setQuantity((prevQty) => {
      let tempQty = prevQty - 1;
      if (tempQty < 1) tempQty = 1;
      return tempQty;
    });
  };

  const addToCartHandler = (product_id, quantity) => {
    if (!user) {
      toast.error("You must be logged in to add products to the cart.");

      return;
    }

    // Passer le token dans l'action
    dispatch(addToCartAsync({ product_id, quantity, token }))
      .unwrap()
      .then(() => {
        toast.success("Product Added Successfully !");
        dispatch(setCartMessageOn(true));
      })
      .catch((error) => {
        // console.error("Erreur lors de l'ajout au panier:", error);
        toast.error("Error adding to cart.");
      });
  };

  const addToFavoriteHandler = (product) => {
    let discountedPrice =
      product.price - product.price * (product?.discountPercentage / 100);
    let totalPrice = quantity * discountedPrice;

    dispatch(
      addTofavorite({ ...product, quantity, totalPrice, discountedPrice })
    );
    dispatch(setfavoriteMessageOn(true));
  };

  const handleThumbnailClick = (image) => {
    setSelectedImage(image);
  };

  return (
    <main className="py-5 bg-whitesmoke">
      <ToastContainer className="custom-toast" />
      <div className="product-single">
        <div className="container">
          <div className="product-single-content bg-white grid">
            <div className="product-single-l">
              <div className="product-img">
                <img
                  src={selectedImage ? IMAGE_URL1 + selectedImage : ""}
                  alt="Product"
                  className="img-cover"
                />
                <div className="product-img-thumbs flex">
                  {[
                    "product_images1",
                    "product_images2",
                    "product_images3",
                  ].map((imgKey) =>
                    product?.[imgKey] ? (
                      <div
                        key={imgKey}
                        className="thumb-item"
                        onClick={() => handleThumbnailClick(product[imgKey])}
                      >
                        <img
                          src={IMAGE_URL1 + product[imgKey]}
                          alt="Thumbnail"
                          className="img-cover"
                        />
                      </div>
                    ) : null
                  )}
                </div>
              </div>
            </div>

            <div className="product-single-r">
              <div className="product-details font-manrope">
                <div className="title fs-20 fw-5">{product?.product_name}</div>

                <div className="price">
                  <div className="flex align-center my-1">
                    <div className="new-price fw-5 font-poppins fs-24 text-orange">
                      {formatPrice(product?.price)}
                    </div>
                  </div>
                </div>

                <div className="qty flex align-center my-4">
                  <div className="qty-text">Quantity:</div>
                  <div className="qty-change flex align-center mx-3">
                    <button
                      type="button"
                      className="qty-decrease flex align-center justify-center"
                      onClick={decreaseQty}
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <div className="qty-value flex align-center justify-center">
                      {quantity}
                    </div>
                    <button
                      type="button"
                      className="qty-increase flex align-center justify-center"
                      onClick={increaseQty}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </div>
                  {product?.stock < 1 && (
                    <div className="qty-error text-uppercase bg-danger text-white fs-12 ls-1 mx-2 fw-5">
                      out of stock
                    </div>
                  )}
                </div>
                <div className="info flex align-center flex-wrap fs-14">
                  <div className="brand">
                    <span className="text-orange fw-5">Category:</span>
                    <span className="mx-1 text-capitalize">
                      {product?.categories_name}
                    </span>
                  </div>
                </div>
                <div className="btns">
                  <button
                    type="button"
                    className="add-to-cart-btn btn"
                    onClick={() => {
                      if (product?.stock > 0) {
                        // Passer les arguments directement
                        addToCartHandler(product.id, quantity);
                      }
                    }}
                    disabled={product?.stock < 1}
                  >
                    <i className="fas fa-shopping-cart"></i>
                    <span className="btn-text mx-2">add to cart</span>
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="add-to-cart-btn btn"
                    onClick={() => addToFavoriteHandler(product)}
                  >
                    <i className="fa-solid fa-heart"></i>
                    <span className="btn-text mx-0"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="product-description">
            <h2>Product Description</h2>
            <p className="para fw-3 fs-15">{product?.product_description}</p>
          </div>
        </div>
      </div>

      {cartMessageStatus && <CartMessage />}
      {favoriteMessageStatus && <FavoriteMessage />}
      {/* <Footer1 /> */}
    </main>
  );
};

export default ProductSinglePages;
